import React from "react";
import { useNavigate, useLocation } from "react-router";

export const Navigation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const getParam = (name) => document.get(name);

  const push = React.useCallback(
    (to, state) => navigate(to, { state }),
    [navigate]
  );

  const replace = React.useCallback(
    (to, state) => navigate(to, { replace: true, state }),
    [navigate]
  );

  const go = React.useCallback((delta) => navigate(delta), [navigate]);

  const back = React.useCallback(() => navigate(-1), [navigate]);

  const forward = React.useCallback(() => navigate(1), [navigate]);

  const reset = React.useCallback(() =>
    navigate.reset({ index: 0, routes: [{ name: "login" }] }),[navigate]
  );

  const reload = React.useCallback(
    () => navigate(0),
    [navigate]
  );

   const openNewTab = React.useCallback((url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  }, []);

  return React.useMemo(
    () => ({
      back,
      forward,
      go,
      push,
      replace,
      reset,
      reload,
      location,
      getParam,
      openNewTab,
    }),
    [back, forward, go, push, replace, reset, reload, location, openNewTab]
  );
};
